import { UtilModule } from 'util/util';
import { loginModule } from './components/login';
import { filtersModule } from './filters';
import { 
	servicesModule, 
	settingsModule
} from './services';
import { componentsModule } from './components';
import { commonUtilModule } from 'util/util';    
import { validatorsModule } from './validators';
import { interceptorsModule } from './Interceptors'
/**
* @ngdoc overview
* @name phoenix
* @module phoenix
* @description
*
* # phoenix (module)
* The phoenix module contains components and services available to any
* application built upon the phoenix platform.
*
* Examples of services provided by this module are:
* - authentication
* - user management
* - local storage 
*  
*/
export const PhoenixModule = angular
	.module('phoenix', [
		'ngMaterial',
		'ngMessages',
		'ui.router',
		UtilModule.name,
		interceptorsModule.name,
		settingsModule.name,
		componentsModule.name,
		commonUtilModule.name,
		servicesModule.name,
		filtersModule.name,
		loginModule.name,
		validatorsModule.name,
		filtersModule.name
	]);



// WEBPACK FOOTER //
// ./src/phoenix/phoenix.ts